import React, { useState } from 'react';
import { message } from 'antd';
import { useNavigate, useLocation } from 'react-router';
import { authActions } from '../../actions/auth';
import './AuthScreen.css';

function ResetPasswordScreen() {
  const navigate = useNavigate();
  const location = useLocation();
  const initialEmail = location.state?.email || '';
  const [form, setForm] = useState({ email: initialEmail, otp: '', newPassword: '' });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (isSubmitting) return;
    setIsSubmitting(true);
    const { email, otp, newPassword } = form;
    try {
      await authActions.resetPassword(email, otp, newPassword);
      message.success('Password reset successful');
      navigate('/login');
    } catch (err) {
      const errorMessage =
        err?.response?.data?.message ||
        err?.response?.data?.error ||
        (err?.response?.status === 404 ? 'Email address not found.' : null) ||
        (err?.response?.status === 429 ? 'Too many attempts. Please wait a few minutes.' : null) ||
        err?.message ||
        'Something went wrong. Please try again.';
      message.error(errorMessage);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="auth-container">
      {[...Array(6)].map((_, i) => (
        <span key={i} className="bubble" />
      ))}
      <div className="auth-card">
        <div className="logo-container">
          <img src="/uro_logo_white.png" alt="URO" className="logo" />
        </div>
        <h2>Reset Password</h2>
        <form className="auth-form" onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="resetEmail">Email</label>
            <input
              id="resetEmail"
              type="email"
              value={form.email}
              onChange={(e) => setForm({ ...form, email: e.target.value })}
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="resetOtp">OTP</label>
            <input
              id="resetOtp"
              type="text"
              value={form.otp}
              onChange={(e) => setForm({ ...form, otp: e.target.value })}
              required
              maxLength={6}
            />
          </div>
          <div className="form-group">
            <label htmlFor="newPassword">New Password</label>
            <input
              id="newPassword"
              type="password"
              value={form.newPassword}
              onChange={(e) => setForm({ ...form, newPassword: e.target.value })}
              required
              minLength={6}
            />
          </div>
          <button
            className="button"
            type="submit"
            disabled={isSubmitting}
            style={{ opacity: isSubmitting ? 0.65 : 1, cursor: isSubmitting ? 'not-allowed' : 'pointer' }}
          >
            {isSubmitting ? 'Resetting…' : 'Reset Password'}
          </button>
          <button
            type="button"
            className="link-button"
            onClick={() => navigate('/login')}
          >
            Back to login
          </button>
        </form>
      </div>
    </div>
  );
}

export default ResetPasswordScreen;
